export default __webpack_public_path__ + "static/media/navbar-scheduled-orange.d1f182ca.svg";